import { cloneDeep, isEmpty } from 'lodash';
import { reverseFormatFormDate, calculateAge } from '@general/js/utils';
import { NeedsAnalysisEligibility } from '@general/js/enums';
import { mapPerson } from '@general/js/utils/JoinNow';
import { mapVeteranCard, formatQuoteLHCABD } from './PersonUtils';

const mapPartnerPayload = (partnerDetailsObj, captureInformationReferenceData, changeCoverData, caiData, convertedCoverType, hospitalSituation) => {
  if (caiData.newCompositionHavePartner) {
    let partnerObj = cloneDeep(caiData.partnerStep);

    if (caiData.showNewPartnerSection) {
      partnerObj = { ...partnerObj, ...cloneDeep(caiData.partnerStep.newPartner) };
    }

    partnerObj.sex = partnerObj.gender;
    const veteranCard = caiData.partnerStep.veteranCard;
    partnerObj.residentialAddress = caiData.policyHolderStep.residentialAddress;

    const noLongerEligibleForVeteran =
      veteranCard.haveVeteranCard &&
      (changeCoverData.step1.eligibility === NeedsAnalysisEligibility.WORK_CONNECTION || changeCoverData.step1.eligibility === NeedsAnalysisEligibility.RELATED);

    const mappedPartnerObj = mapPerson(
      mapVeteranCard(partnerObj, veteranCard, noLongerEligibleForVeteran),
      captureInformationReferenceData,
      { coverType: convertedCoverType },
      true,
    );

    mappedPartnerObj.age = calculateAge(reverseFormatFormDate(partnerObj.DOB));

    // If new partner, there is no existing lhcOverrule - send as false
    const partnerLHCABD = formatQuoteLHCABD(partnerObj, hospitalSituation, !caiData.showNewPartnerSection && partnerDetailsObj?.lhcOverrule !== null);

    mappedPartnerObj.lifetimeHealthCoverOverrule = !isEmpty(partnerLHCABD?.lhc) ? { ...partnerLHCABD?.lhc } : null;
    mappedPartnerObj.ageBasedDiscount = !isEmpty(partnerLHCABD?.abd) ? { ...partnerLHCABD?.abd } : null;

    return mappedPartnerObj;
  }

  return null;
};

export default mapPartnerPayload;
